import { defaultBody } from '@/shared/functions/maps';
import api from '../axios-api';
import { clean_logout } from '@/shared/functions/logout';


const login = async ({ username, password }) => {
  const VIEW = 'Login';
  const basePath = `/${VIEW}/`;
  try {
    const response = await api.post(basePath, {
      data: {
        type: VIEW,
        attributes: {
          email: username,
          password
        }
      }
    });
    
    const { access, refresh, user } = response.data.data;
    
    if (!access || !refresh) {
      throw new Error('Invalido token');
    }
    
    await verifyToken(access).then(() => {
      localStorage.setItem('tokenAccess', access);
      localStorage.setItem('tokenRefresh', refresh);
      
      // Salvar os dados do usuário
      if (user) {
        localStorage.setItem('idUser', user.id);
        localStorage.setItem('nameUser', user.name);
        localStorage.setItem('emailUser', user.email);
        
        if (user.is_superuser) {
          localStorage.setItem('isSuperuser', 'true');
        }
      }
    });
    
    // Carregar permissões do usuário
    try {
      const { usePermissions } = await import('@/composables/usePermissions');
      const { refreshPermissions } = usePermissions();
      await refreshPermissions();
    } catch (error) {
      console.error('Erro ao carregar permissões:', error);
    }
    
    return response.data;
  } catch (error) {
    clean_logout();
    if (error?.response) {
      console.error('Error response:', error.response);
      throw new Error(`Login falha: ${error.response.status} ${error.response.statusText}`);
    } else if (error?.request) {
      console.error('Error request:', error.request);
      throw new Error('Login falha: servidor não responde');
    } else {
      console.error('Error message:', error?.message);
      throw new Error(`Login falha: ${error?.message}`);
    }
  }
};

const logout = async () => {
  try {
    // Limpar permissões do cache
    try {
      const { usePermissions } = await import('@/composables/usePermissions');
      const { clearPermissions } = usePermissions();
      clearPermissions();
    } catch (error) {
      console.error('Erro ao limpar permissões:', error);
    }
    
    // Tentar fazer logout no servidor (não bloqueia se falhar)
    try {
      await api.post('auth/logout/', {});
    } catch (error) {
      console.warn('Erro ao fazer logout no servidor:', error);
    }
  } finally {
    // Sempre limpar dados locais, independente do resultado da requisição
    clean_logout();
  }
};

const register = async (formData) => {
  const VIEW = 'AuthApiRegister';
  const basePath = `/${VIEW}/`;
  try {
    const newBody = defaultBody({ "MODEL": VIEW, "body": formData });
    const response = await api.post(basePath, newBody);
    return response.data;
  } catch (error) {
    throw error.message;
  }
};

const verifyToken = async (token = localStorage.getItem('tokenAccess')) => {
  if (!token) {
    throw new Error('Token not found');
  }
  try {
    const VIEW = 'TokenVerifyView';
    const basePath = `/${VIEW}/`;
    await api.post(basePath, {
      data: {
        type: 'TokenVerifyView',
        attributes: {
          token: token
        }
      }
    });
  } catch (error) {
    clean_logout();
    console.error('Logout error:', error);
    throw error;
  }
};

export default {
  login,
  logout,
  register,
  verifyToken
};
